import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BookOpen, Calendar, ShoppingCart, Snowflake } from 'lucide-react';
export const ProductShowcase = () => {
  return <section className="bg-white px-4 py-10 md:py-20 lg:px-8" id="product" data-id="element-167">
      <div className="mx-auto max-w-6xl" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 text-center" data-id="element-169">
          <h2 className="mb-4 font-serif text-3xl font-bold text-text-dark md:text-5xl" data-id="element-170">
            THE PEACEFUL DINNER PROTOCOL: THE 4 SEASONS
          </h2>
          <p className="mx-auto max-w-3xl text-xl text-text-dark/80" data-id="element-171">
            The complete digital step-by-step plan to creating a month of
            protected dinners in just four hours.
          </p>
        </motion.div>

        <div className="grid gap-12 lg:grid-cols-2 lg:items-center" data-id="element-172">
          {/* Left: Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1" data-id="element-173">
            <img src="https://cdn.magicpatterns.com/uploads/sjb1CziNvTn6yve6sV7ZeL/bonos.jpg" alt="The 4 Seasons Guides" className="w-full rounded-2xl shadow-xl" data-id="element-174" />
          </motion.div>

          {/* Right: Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 flex flex-col space-y-8 lg:order-2" data-id="element-175">
            <p className="text-lg text-text-dark" data-id="element-176">
              Unlike typical "freezer meal" guides that end up as a tasteless,
              mushy mess, our Layered Freshness Shield system ensures that every
              ingredient keeps its original texture and vibrant color.
            </p>

            <div data-id="element-177">
              <h3 className="mb-6 font-serif text-2xl font-bold text-terracotta" data-id="element-178">
                What's inside the system:
              </h3>
              <ul className="space-y-4" data-id="element-179">
                <li className="flex items-start space-x-3" data-id="element-180">
                  <Snowflake className="mt-1 h-5 w-5 flex-shrink-0 text-sage" data-id="element-181" />
                  <span className="text-text-dark" data-id="element-182">
                    <strong data-id="element-183">Exclusive Freezer-Optimized Recipes:</strong>{' '}
                    Designed to never lose their flavor.
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-184">
                  <ShoppingCart className="mt-1 h-5 w-5 flex-shrink-0 text-sage" data-id="element-185" />
                  <span className="text-text-dark" data-id="element-186">
                    <strong data-id="element-187">Comprehensive Grocery Lists:</strong> Get in and out
                    of the store in record time.
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-188">
                  <Calendar className="mt-1 h-5 w-5 flex-shrink-0 text-sage" data-id="element-189" />
                  <span className="text-text-dark" data-id="element-190">
                    <strong data-id="element-191">Monthly Convenience Plan:</strong> Simple
                    organization (includes blank templates).
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-192">
                  <BookOpen className="mt-1 h-5 w-5 flex-shrink-0 text-sage" data-id="element-193" />
                  <span className="text-text-dark" data-id="element-194">
                    <strong data-id="element-195">Lifetime Access:</strong> Including all future
                    updates.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>

        {/* Bonuses Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-20 rounded-3xl bg-white p-8 shadow-xl md:p-12 border border-gray-100" data-id="element-196">
          <div className="grid gap-10 md:grid-cols-2 md:items-center" data-id="element-197">
            <div data-id="element-198">
              <h3 className="mb-6 font-serif text-2xl font-bold text-terracotta" data-id="element-199">
                INCLUDED BONUSES:
              </h3>
              <ul className="space-y-4 text-lg" data-id="element-200">
                <li className="flex items-center space-x-3" data-id="element-201">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-sm font-bold text-terracotta" data-id="element-202">
                    1
                  </span>
                  <span className="font-medium text-text-dark" data-id="element-203">
                    Food Budget Savings Guide.
                  </span>
                </li>
                <li className="flex items-center space-x-3" data-id="element-204">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-sm font-bold text-terracotta" data-id="element-205">
                    2
                  </span>
                  <span className="font-medium text-text-dark" data-id="element-206">
                    Freezer Clean-Out & Organization Challenge.
                  </span>
                </li>
                <li className="flex items-center space-x-3" data-id="element-207">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-sm font-bold text-terracotta" data-id="element-208">
                    3
                  </span>
                  <span className="font-medium text-text-dark" data-id="element-209">
                    Quick-Prep Side Dish Master Sheet.
                  </span>
                </li>
              </ul>

              <div className="mt-8 space-y-4" data-id="element-210">
                <p className="text-xl text-gray-400 line-through decoration-red-400 decoration-2" data-id="element-211">
                  Total Value: $148
                </p>
                <a href="#mid-pricing" onClick={e => {
                e.preventDefault();
                document.getElementById('mid-pricing')?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center'
                });
              }} className="group inline-flex w-full items-center justify-center rounded-full bg-terracotta px-8 py-4 text-lg font-bold text-white shadow-lg transition-all hover:bg-[#d6761b] hover:shadow-xl hover:-translate-y-0.5 md:w-auto" data-id="element-212">
                  Get the 4 Seasons Bundle today for only $17
                  <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-213" />
                </a>
              </div>
            </div>

            <div className="relative overflow-hidden rounded-xl shadow-lg" data-id="element-214"></div>
          </div>

          {/* Individual Bonus Images */}
          <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-3" data-id="element-215">
            <img src="https://cdn.magicpatterns.com/uploads/hC1FDYXsZqgoicuP6kRKrm/bono_1.jpg" alt="Food Budget Savings Guide" className="w-full rounded-xl shadow-md" data-id="element-216" />
            <img src="https://cdn.magicpatterns.com/uploads/oRg1ZewH1gMzB6K3GiyuvG/bono_2.jpg" alt="Quick-Prep Side Dish Master Sheet" className="w-full rounded-xl shadow-md" data-id="element-217" />
            <img src="https://cdn.magicpatterns.com/uploads/5XFfrQVMuQLpoyUFARFnc8/bono_3.jpg" alt="Freezer Clean-Out & Organization Challenge" className="w-full rounded-xl shadow-md" data-id="element-218" />
          </div>
        </motion.div>
      </div>
    </section>;
};